import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'service.home',
    defaultMessage: 'Home',
  },
  serviceTitle: {
    id: 'service.title',
    defaultMessage: 'Service',
  },
  viewTitle: {
    id: 'service.view.title',
    defaultMessage: 'View Service',
  },
  detailTitle: {
    id: 'service.detail.title',
    defaultMessage: 'Service Detail',
  },
  status: {
    active: {
      id: 'service.status.active',
      defaultMessage: 'Active',
    },
    inactive: {
      id: 'service.status.inactive',
      defaultMessage: 'InActive',
    },
    hidden: {
      id: 'service.status.hidden',
      defaultMessage: 'Hidden',
    },
  },
  label: {
    serviceId: {
      id: 'service.label.serviceId',
      defaultMessage: 'Service ID',
    },
    serviceName: {
      id: 'service.label.serviceName',
      defaultMessage: 'Name',
    },
    publicServiceName: {
      id: 'service.label.publicServiceName',
      defaultMessage: 'Public Name',
    },
    serviceIcon: {
      id: 'service.label.serviceIcon',
      defaultMessage: 'Service Icon',
    },
    serviceBanner: {
      id: 'service.label.serviceBanner',
      defaultMessage: 'Service Banner',
    },
    status: {
      id: 'service.label.status',
      defaultMessage: 'Status',
    },
    danaDivisionId: {
      id: 'service.label.danaDivisionId',
      defaultMessage: 'Division ID',
    },
    defaultForm: {
      id: 'service.label.defaultForm',
      defaultMessage: 'Default Form',
    },
    serviceCategory: {
      id: 'service.label.serviceCategory',
      defaultMessage: 'Service Category',
    },
    aggregator: {
      id: 'service.label.aggregator',
      defaultMessage: 'Aggregator',
    },
    archived: {
      id: 'service.label.archived',
      defaultMessage: 'Archived',
    },
    createdat: {
      id: 'service.label.createdat',
      defaultMessage: 'Created At',
    },
    updatedat: {
      id: 'service.label.updatedat',
      defaultMessage: 'Updated At',
    },
    keyword: {
      id: 'service.label.keyword',
      defaultMessage: 'Universal Keyword',
    },
    nameMask: {
      id: 'service.label.nameMask',
      defaultMessage: 'Account Namecheck Masking',
    },
    restore: {
      id: 'service.label.restore',
      defaultMessage: 'restore',
    },
    transactionFee: {
      id: 'service.label.transactionFee',
      defaultMessage: 'Transaction Fee',
    },
  },
  btn: {
    edit: {
      id: 'service.btn.edit',
      defaultMessage: 'Edit',
    },
    restore: {
      id: 'service.btn.restore',
      defaultMessage: 'Restore',
    },
    cancel: {
      id: 'service.btn.cancel',
      defaultMessage: 'Cancel',
    },
  },
  biller: {
    label: {
      no: {
        id: 'service.biller.label.no',
        defaultMessage: 'No',
      },
      name: {
        id: 'service.biller.label.name',
        defaultMessage: 'Name',
      },
      billerId: {
        id: 'service.biller.label.billerId',
        defaultMessage: 'Biller ID',
      },
      playgroundStatus: {
        id: 'service.biller.label.playgroundStatus',
        defaultMessage: 'Playground Status',
      },
      skywalkerStatus: {
        id: 'service.biller.label.skywalkerStatus',
        defaultMessage: 'Skywalker Status',
      },
    },
    detailService: {
      id: 'service.biller.detail.title',
      defaultMessage: 'Biller Under This Service',
    },
    btn: {
      create: {
        id: 'service.biller.create',
        defaultMessage: 'Add New Biller',
      },
    },
  },
  confirmation: {
    title: {
      id: 'service.confirmation.title',
      defaultMessage: 'Confirmation',
    },
    archive: {
      id: 'service.confirmation.archive',
      defaultMessage: 'Are you sure want to {status} this service ?',
    },
    extra: {
      restore: {
        id: 'service.confirmation.extra.restore',
        defaultMessage: 'All billers under this service will not be restored',
      },
    },
    message: {
      restore: {
        id: 'service.confirmation.message.restore',
        defaultMessage: 'This service has been restored',
      },
    },
  },
});
